module.exports = __webpack_public_path__ + "static/media/strutture-di-contenimento-reti-bianca-noleggiocampi.cdefc10f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/strutture-di-contenimento/reti/strutture-di-contenimento-reti-bianca-noleggiocampi.jpg
// module id = 661
// module chunks = 0